import { render, staticRenderFns } from "./ProductImagePreview.vue?vue&type=template&id=2303e673&"
import script from "./ProductImagePreview.vue?vue&type=script&lang=ts&"
export * from "./ProductImagePreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports